import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_fixed_asset_register_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    type: fromDatatype.VarcharArrayDatatypeInterface;
    category_code: fromDatatype.VarcharArrayDatatypeInterface;
    company_code: fromDatatype.VarcharArrayDatatypeInterface;
    branch_code: fromDatatype.VarcharArrayDatatypeInterface;
    location_code: fromDatatype.VarcharArrayDatatypeInterface;
    currency: fromDatatype.VarcharArrayDatatypeInterface;
    gl_code: fromDatatype.VarcharArrayDatatypeInterface;
    purchase_date: fromDatatype.TimestampTzDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    serial_number: fromDatatype.VarcharArrayDatatypeInterface;
    warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
    employee_name: fromDatatype.VarcharArrayDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: fromDatatype.VarcharArrayDatatypeInterface;
    processed: fromDatatype.VarcharArrayDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: any;
    acl_policy: any;
    acl_config: any;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_fi_fixed_asset_register_import_file_helper_RowClass implements bl_fi_fixed_asset_register_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    type: fromDatatype.VarcharArrayDatatypeInterface;
    category_code: fromDatatype.VarcharArrayDatatypeInterface;
    company_code: fromDatatype.VarcharArrayDatatypeInterface;
    branch_code: fromDatatype.VarcharArrayDatatypeInterface;
    location_code: fromDatatype.VarcharArrayDatatypeInterface;
    currency: fromDatatype.VarcharArrayDatatypeInterface;
    gl_code: fromDatatype.VarcharArrayDatatypeInterface;
    purchase_date: fromDatatype.TimestampTzDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    serial_number: fromDatatype.VarcharArrayDatatypeInterface;
    warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
    employee_name: fromDatatype.VarcharArrayDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: fromDatatype.VarcharArrayDatatypeInterface;
    processed: fromDatatype.VarcharArrayDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: any;
    acl_policy: any;
    acl_config: any;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
}